import React from 'react'
import MainBanner from '../Generator/MainBanner';
import EventSchedulesOne from '../Generator/EventSchedulesOne';
import Footer from '../Common/Footer';
 
class ScheduleOne extends React.Component {
    render(){
        return (
            <React.Fragment>
                <MainBanner />
                <EventSchedulesOne />
                <Footer />
            </React.Fragment>
        );
    }
}
 
export default ScheduleOne;